<template>
  <div style="margin: 20px">
    <v-overlay :value="caricamento">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-toolbar dense color="indigo" dark align="center">
        <v-row class="mt-1">
          <v-col cols="3" class="mt-3" align="left">
            <v-toolbar-title>Gestione Utenti</v-toolbar-title>
          </v-col>
          <v-col cols="3" class="mt-3" align="left">
            <v-text-field
              v-model="filter"
              solo
              dense
              append-icon="mdi-magnify"
              clearable
              light
              placeholder="Ricerca per nome"
            ></v-text-field>
          </v-col>
          <v-col class="mt-4" cols="1">
            <!--<v-btn small light @click="setUtenti">
              <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>-->
          </v-col>
          <v-col class="mt-4" cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  light
                  @click="scegliNuovoInserimento"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary">mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Nuovo Utente</span>
            </v-tooltip>
          </v-col>
          <v-col class="mt-4" cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  light
                  @click="filterActivePerson"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary">mdi-account-check</v-icon>
                </v-btn>
              </template>
              <span>Utenti Attivi / Disattivati</span>
            </v-tooltip>
          </v-col>

          <v-col cols="2" class="mt-4" align="right">
            <v-btn small light @click="aggiorna">
              <v-icon color="primary">mdi-autorenew</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1" class="mt-4" align="right">
            <v-btn small light @click="$router.push('/home/amministrazione')">
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-container>
        <v-data-table :headers="tabella.testata" :items="filtraUtente(filter)">
          <!-- BOTTONE MODIFICA -->
          <template v-slot:[`item.modifica_btn`]="{ item }">
            <v-btn
              small
              @click="mostraDialog(item, tabella.dati)"
              :disabled="item.validita != 1"
            >
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <!-- BOTTONE Stampa -->
          <template v-slot:[`item.print_btn`]="{ item }">
            <v-btn
              small
              @click="printLoginQr(item)"
              :disabled="item.validita != 1"
            >
              <v-icon color="primary">mdi-qrcode</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.key_btn`]="{ item }">
            <v-btn
              small
              light
              @click="generateKey(item)"
              :disabled="item.key != null"
            >
              <v-icon color="primary">mdi-key</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.unblock_btn`]="{ item }">
            <v-btn
              small
              light
              @click="unblock(item)"
              :disabled="item.accesso_web < 9"
            >
              <v-icon color="primary">mdi-lock</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.make_admin`]="{ item }">
            <v-btn small light @click="clickMakeAdmin(item)">
              <v-icon :color="item.is_admin == 1 ? 'success' : 'primary'">
                mdi-account-tie
              </v-icon>
            </v-btn>
          </template>

          <!-- COLONNA ATTIVO -->
          <template v-slot:[`item.attivo`]="{ item }">
            <v-icon :color="item.attivo == 1 ? 'success' : 'error'">{{
              item.attivo == 1 ? "mdi-check" : "mdi-close"
            }}</v-icon>
          </template>
          <!-- COLONNA PROFILO UTENTE -->
          <template v-slot:[`item.id_profilo_utente`]="{ item }">
            <span>{{ getCodiceProfilo(item.id_profilo_utente) }}</span>
          </template>
          <!-- COLONNA NOTE -->
          <template v-slot:[`item.note`]="{ item }">
            <span
              :title="item.note"
              style="
                display: block;
                max-width: 150px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              "
              >{{ item.note }}</span
            >
          </template>
          <!-- BOTTONE VALIDITA -->
          <template v-slot:[`item.rimuovi_btn`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="toggleValidita(item)"
                  v-on="on"
                  v-bind="attrs"
                >
                  <v-icon :color="item.validita == 1 ? 'error' : 'primary'">{{
                    item.validita == 1 ? "mdi-close" : "mdi-restore"
                  }}</v-icon>
                </v-btn>
              </template>
              <span
                >{{
                  item.validita == 1 ? "Elimina utente" : "Ripristina utente"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
    <v-dialog v-model="passwordDialog" width="500px">
      <v-card>
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">Genera Chiave</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="confirmPasswordDialog" small>
            <v-icon color="success">mdi-check</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="passwordDialog = false" small>
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="font-size: 18px">
            Inserire la password attualmente in uso per l'utente
            {{ printItem.nome }} {{ printItem.cognome }}.
          </span>

          <v-text-field
            class="mt-5"
            outlined
            style="border-radius: 0px"
            @keyup.enter="confirmPasswordDialog"
            :type="show_pwd_dbs ? 'text' : 'password'"
            v-model="enteredPassword"
          >
            <template v-slot:append>
              <v-icon @click="show_pwd_dbs = !show_pwd_dbs" color="dark-grey">
                {{ show_pwd_dbs ? "mdi-eye" : "mdi-eye-off" }}
              </v-icon>
            </template>
          </v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.mostra" persistent width="1500">
      <v-card>
        <v-toolbar dense color="indigo" dark>
          <v-toolbar-title>{{
            newUser == false ? "Modifica Utente" : "Nuovo Utente"
          }}</v-toolbar-title>
          <v-spacer />
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                light
                @click="salvaDialog"
                class="mr-5"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span> Salva </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                light
                @click="
                  dialog.buffer.accesso_web > 0
                    ? (dialog.buffer.accesso_web = 0)
                    : (dialog.buffer.accesso_web = 9);
                  salvaDialog();
                "
              >
                <v-icon
                  :color="dialog.buffer.accesso_web > 0 ? 'error' : 'success'"
                  >{{
                    dialog.buffer.accesso_web > 0 ? "mdi-lock" : "mdi-lock-open"
                  }}</v-icon
                >
              </v-btn>
            </template>
            <span>
              {{
                dialog.buffer.accesso_web > 0
                  ? "Sblocca accesso"
                  : "Blocca accesso"
              }}
            </span>
          </v-tooltip>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                light
                @click="dialog.mostra = false"
              >
                <v-icon color="error">mdi-keyboard-backspace</v-icon>
              </v-btn>
            </template>
            <span> Annulla </span>
          </v-tooltip>
        </v-toolbar>
        <v-container>
          <v-form ref="form">
            <v-row align="center">
              <v-col cols="1">
                <v-icon>mdi-account</v-icon>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="Nome"
                  required
                  :rules="regole.no_null_str"
                  v-model="dialog.buffer.nome"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="Cognome"
                  required
                  :rules="regole.no_null_str"
                  v-model="dialog.buffer.cognome"
                />
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  label="Attivo"
                  :true-value="1"
                  :false-value="0"
                  v-model="dialog.buffer.attivo"
                />
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  label="Attivo QuickTeam"
                  :true-value="1"
                  :false-value="0"
                  v-model="dialog.buffer.attivo_quickhr"
                />
              </v-col>
              <v-col cols="3">
                <v-select
                  label="Profilo"
                  required
                  :rules="regole.no_null_str"
                  v-model="dialog.buffer.id_profilo_utente"
                  :items="profili"
                  item-text="des_profilo_utente"
                  item-value="id_profilo_utente"
                />
              </v-col>
            </v-row>
            <v-divider />
            <v-row align="center">
              <v-col cols="1">
                <v-icon>mdi-text-account</v-icon>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  required
                  :rules="regole.no_null_str"
                  label="Username"
                  v-model="dialog.buffer.username"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-if="
                    dialog.buffer.new_pass == true ||
                    dialog.buffer.new_pass === undefined
                  "
                  required
                  :rules="regole.no_null_str"
                  label="Password"
                  v-model="dialog.buffer.password"
                />
                <v-btn
                  v-if="dialog.buffer.new_pass == false"
                  @click="cambiaPassword"
                >
                  <v-icon color="amber darken-3">mdi-lock</v-icon>
                  <span>Cambia Password</span>
                </v-btn>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="Cod. Fiscale"
                  v-model="dialog.buffer.cod_fiscale"
                />
              </v-col>
              <v-col cols="5">
                <v-text-field label="Note" v-model="dialog.buffer.note" />
              </v-col>
            </v-row>
            <v-divider />
            <v-row align="center">
              <v-col cols="1">
                <v-icon>mdi-email</v-icon>
              </v-col>
              <v-col cols="3">
                <v-select
                  label="Mittente mail contabilità"
                  required
                  :rules="regole.no_null_str"
                  v-model="dialog.buffer.mittente_email"
                  :items="mittenti_mail"
                  item-text="des"
                  item-value="cod"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field label="Email" v-model="dialog.buffer.email" />
              </v-col>
              <v-col cols="1.5">
                <v-checkbox
                  label="Registrazione orari"
                  v-model="dialog.buffer.orari_attivi"
                  :true-value="1"
                  :false-value="0"
                />
              </v-col>
              <v-col cols="1.5">
                <v-checkbox label="Email credenziali" v-model="boolSendEmail" />
              </v-col>
              <v-col cols="1.5" v-if="is_admin == 1">
                <v-checkbox
                  label="Ripristina chiave utente"
                  v-model="boolResetKey"
                />
              </v-col>
              <v-col cols="1.5">
                <v-checkbox
                  label="Ripristina chiave admin"
                  v-model="pwd_utente_amm_db"
                  v-if="is_admin == 1"
                  :false-value="0"
                  :true-value="1"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
      <v-overlay :value="caricamento">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="dialog_make_admin" width="700px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col cols="4">
              <v-toolbar-title class="white--text">
                Utente Amministratore
              </v-toolbar-title>
            </v-col>

            <v-col cols="4" align="center">
              <v-btn @click="makeAdmin" class="mr-5" small>
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>
            </v-col>

            <v-col cols="4" align="right">
              <v-btn @click="dialog_make_admin = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <v-container class="mt-5" fluid>
            <v-row dense>
              <v-col cols="12">
                <span style="font-size: 18px">
                  Confermi la modifica dello stato di questo utente?
                </span>
              </v-col>
            </v-row>
            <v-row class="mt-5" v-if="utente_sel.is_admin == 0">
              <v-col cols="12">
                <span style="font-size: 18px">
                  Per conferire all'utente i privilegi di amministratore,
                  inserire la sua password attuale di accesso al sistema.
                </span>
              </v-col>
            </v-row>
            <v-row class="mt-5" dense v-if="utente_sel.is_admin == 0">
              <v-col cols="4"> </v-col>
              <v-col cols="4">
                <v-text-field
                  class="center--input"
                  dense
                  outlined
                  type="password"
                  style="width: 250px; border-radius: 0px"
                  v-model="utente_sel.password"
                ></v-text-field>
              </v-col>
              <v-col cols="4"> </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog persistent v-model="dialog_scelta_inserimento" width="700px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Nuovo Utente </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_scelta_inserimento = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Vuoi creare un utente nuovo o aggiornarne uno già presente su
            QuickTeam?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mr-5"
                    @click="
                      dialog_scelta_inserimento = false;
                      mostraDialog(null, tabella.dati);
                    "
                    height="180px"
                    x-large
                  >
                    <div style="width: 150px; text-align: center">
                      Voglio Creare <br />
                      Un Nuovo <br />
                      Utente Da 0
                    </div>
                  </v-btn>

                  <v-btn
                    @click="
                      dialog_scelta_inserimento = false;
                      openSelezioneRagioneSociale();
                    "
                    height="180px"
                    x-large
                  >
                    Voglio <br />
                    Modificare <br />
                    Un Utente <br />
                    Di QuickTeam
                    <v-img
                      style="margin: 0 auto; display: inline-block"
                      max-width="80px"
                      :src="logo_quick_hr"
                    />
                  </v-btn>
                  <v-spacer></v-spacer>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di scelta della ragione sociale -->
    <v-dialog v-model="dialog_scelta_ragione_sociale" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Ragione Sociale
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_scelta_ragione_sociale = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Seleziona la ragione sociale
          </span>

          <v-container class="mt-5" fluid>
            <v-row align="center" justify="start">
              <v-col class="my-0 py-0" justify="center" cols="6">
                <v-text-field
                  dense
                  label="Filtro RS"
                  outlined
                  style="border-radius: 0px"
                  v-model="filtro_ragione_sociale"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="header_scelta_ragione_sociale"
                  :items="
                    items_ragioni_sociali
                      .filter((r) => r.id_anagrafica != null)
                      .filter(
                        (e) =>
                          e.ragione_sociale?.toUpperCase().includes(filtro_ragione_sociale?.toUpperCase()) ||
                          filtro_ragione_sociale == '' ||
                          filtro_ragione_sociale == null
                      )
                  "
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="getUtentiAzienda(item.id_anagrafica)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="success"> mdi-check </v-icon>
                        </v-btn>
                      </template>
                      <span>Seleziona</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di scelta degli utenti -->
    <v-dialog v-model="dialog_scelta_utente" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Utente
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_scelta_utente = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-2" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" dense justify="center">
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="filtro_nome_utente"
                  label="Nominativo"
                  @input="filtraSelezioneUtente"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="
                        filtro_nome_utente = null;
                        items_utenti_selezionabili_filtrati =
                          items_utenti_selezionabili;
                      "
                      color="error"
                      v-if="
                        filtro_nome_utente !== '' && filtro_nome_utente != null
                      "
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="header_utenti_selezionabili"
                  :items="items_utenti_selezionabili_filtrati"
                >
                  <!-- Colonna della selezione utente -->
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="
                            dialog_scelta_utente = false;
                            mostraDialog(
                              item,
                              items_utenti_selezionabili_filtrati
                            );
                          "
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="success"> mdi-check </v-icon>
                        </v-btn>
                      </template>
                      <span>Seleziona</span>
                    </v-tooltip>
                  </template>

                  <!-- Colonna del nominativo -->
                  <template v-slot:[`item.nominativo`]="{ item }">
                    {{ item.nome }} {{ item.cognome }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      style="position: fixed; bottom: 10px"
      dark
      :color="alert.error == true ? 'error' : 'light-green darken-2'"
      v-model="alert.show"
    >
      {{ alert.message }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="alert.show = false">Chiudi</v-btn>
      </template>
    </v-snackbar>
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import logo_quick_hr from "../../assets/logo_quick_hr.png";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "GestioneUtenti",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      caricamento: false,
      cod_profilo: null,
      dialog_scelta_inserimento: false,
      filtro_attivo: false,
      filtro_nome_utente: null,
      filtro_ragione_sociale: null,
      show_pwd_dbs: false,
      utente_sel: new Object(),
      is_admin: null,
      logo_quick_hr: logo_quick_hr,
      newUser: false,
      boolSendEmail: false,
      boolResetKey: false,
      enteredPassword: "",
      pwd_utente_amm_db: 0,
      printItem: {},
      passwordDialog: false,
      alert: {
        show: false,
        message: null,
        error: false,
      },
      dialog: {
        buffer: {
          nome: null,
          cognome: null,
          cod_fiscale: null,
          attivo: 0,
          attivo_quickhr: 0,
          id_profilo_utente: null,
          id_azienda: null,
          username: null,
          password: null,
          email: null,
          note: null,
          orari_attivi: null,
          validita: 1,
          new_pass: true,
          id_utente: null,
          id_personale: -1,
          mittente_email: "default",
          accesso_web: null,
        },
        indice: -1,
        mostra: false,
      },
      dialog_make_admin: false,
      dialog_scelta_ragione_sociale: false,
      dialog_scelta_utente: false,
      filter: null,
      azienda: [],
      profili: [],
      utenti_ori: [],
      header_utenti_selezionabili: [
        {
          text: "Seleziona",
          value: "selezione",
          sortable: false,
        },
        {
          text: "Nominativo",
          value: "nominativo",
          sortable: false,
        },
      ],
      header_scelta_ragione_sociale: [
        {
          text: "Seleziona",
          value: "selezione",
          sortable: false,
        },
        {
          text: "Ragione Sociale",
          value: "ragione_sociale",
          sortable: false,
        },
      ],
      items_ragioni_sociali: [],
      items_utenti_selezionabili: [],
      items_utenti_selezionabili_filtrati: [],
      regole: {
        no_null_str: [
          (valore) =>
            (valore != null && valore != undefined
              ? valore.toString().length > 0
              : false) || "Campo obbligatorio",
        ],
        no_null_num: [
          (valore) =>
            (valore != null &&
              valore != undefined &&
              !isNaN(valore) &&
              valore > 0) ||
            "Campo obbligatorio",
        ],
      },
      tabella: {
        testata: [
          {
            text: null,
            value: "modifica_btn",
            sortable: false,
            align: "left",
          },
          {
            text: null,
            value: "print_btn",
            sortable: false,
            align: "left",
          },
          {
            text: null,
            value: "invio_email",
            sortable: false,
            align: "left",
          },
          { text: "Nome", value: "nome" },
          { text: "Cognome", value: "cognome" },
          { text: "Attivo", value: "attivo" },
          { text: "Profilo Utente", value: "id_profilo_utente" },
          { text: "Username", value: "username" },
          { text: "Email", value: "email", sortable: false },
          { text: "Note", value: "note", sortable: false },
          {
            text: null,
            value: "rimuovi_btn",
            sortable: false,
            align: "right",
          },
        ],
        dati: [],
      },
      mittenti_mail: [
        { cod: "default", des: "Mail default quickview" },
        { cod: "azienda", des: "Mail aziendale generica" },
        { cod: "persona", des: "Mail aziendale personale" },
      ],
    };
  },
  mounted() {
    this.cod_profilo = localStorage.cod_profilo;
    // Chiamata per avere i dati.
    this.aggiorna();

    // Chiamata per vedere (eventualmente) le colonne riservate agli amministratori.
    this.getUtenteAttuale();
  },
  methods: {
    clickMakeAdmin(arg) {
      this.utente_sel = {
        is_admin: arg.is_admin,
        password: null,
        id_utente: arg.id_utente,
      };
      this.dialog_make_admin = true;
    },
    async getUtenteAttuale() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getutenteattuale",
          token: localStorage.getItem("user_token"),
        },
      };

      return this.$store
        .dispatch("api6", request)
        .then((res) => {
          if (res.status == 200) {
            this.is_admin = res.data.result.is_admin;

            // Se è un amministratore, gli faccio vedere le colonne riservate.
            if (this.is_admin == 1) {
              // Aggiungo il bottone per nominare un amministratore.
              this.tabella.testata.splice(2, 0, {
                text: "Amministratore",
                value: "make_admin",
                sortable: false,
                align: "left",
              });

              // Aggiungo il bottone per bloccare il profilo.
              this.tabella.testata.splice(2, 0, {
                text: "Rimuovi Blocco Login",
                value: "unblock_btn",
                sortable: false,
                align: "left",
              });

              /* Aggiungo un bottone per rigenerare la chiave utente
               * crittografica per la prima volta. */
              this.tabella.testata.splice(2, 0, {
                text: "Genera Chiave Utente",
                value: "key_btn",
                sortable: false,
                align: "left",
              });
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i privilegi di questo utente."
            );
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i privilegi di questo utente."
          );
          return false;
        });
    },
    filtraSelezioneUtente() {
      // Se il filtro è resettato non faccio niente.
      if (this.filtro_nome_utente === "" || this.filtro_nome_utente == null) {
        this.items_utenti_selezionabili_filtrati = JSON.parse(
          JSON.stringify(this.items_utenti_selezionabili)
        );
        return;
      }

      // Resetto l'array degli utenti selezionabili filtrati
      this.items_utenti_selezionabili_filtrati = new Array();

      // Metto gli utenti che soddisfano il filtro.
      this.items_utenti_selezionabili.forEach((elem) => {
        if (`${elem.nome} ${elem.cognome}`.toUpperCase().includes(this.filtro_nome_utente?.toUpperCase())) {
          this.items_utenti_selezionabili_filtrati.push(elem);
        }
      });
    },
    makeAdmin() {
      if (
        this.utente_sel.password == null ||
        (this.utente_sel.password == "" && this.utente_sel.is_admin == 0)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire la password per rendere i dati riservati accessibili a questo utente."
        );
        return;
      }

      let request = {
        controller: "secure",
        method: "PUT",
        richiesta: {
          action: "makeadmin",
          token: localStorage.getItem("user_token"),
          id_utente: this.utente_sel.id_utente,
        },
      };

      if (this.utente_sel.is_admin == 0)
        request.richiesta.password = this.utente_sel.password;

      return this.$store
        .dispatch("api6", request)
        .then((res) => {
          if (res.status == 200) {
            this.getUtenti();
            this.$refs.SnackbarQV.print(
              "success",
              "Privilegi gestiti con successo."
            );
            this.dialog_make_admin = false;
            this.utente_sel = new Object();
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Non è stato possibile modificare i privilegi di accesso."
            );
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile modificare i privilegi di accesso."
          );
          return false;
        });
    },
    getUtentiAzienda(arg) {
      this.caricamento = true;
      const request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getutentiazienda",
          token: localStorage.user_token,
          id_anagrafica: arg == null ? "NULL" : arg,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.caricamento = false;
            this.items_utenti_selezionabili = res.data.result.utenti;
            this.items_utenti_selezionabili_filtrati = res.data.result.utenti;
            this.filtro_nome_utente = null;
            this.dialog_scelta_utente = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento = false;
          this.$refs.SnackbarQV.print("error", "Errore: " + err.toString());
        });
    },
    openSelezioneRagioneSociale() {
      this.caricamento = true;
      const request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getragionisociali",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.caricamento = false;
            this.items_ragioni_sociali = res.data.result.aziende;
            if (this.items_ragioni_sociali.length == 1) {
              this.getUtentiAzienda(this.items_ragioni_sociali[0].id_anagrafica);
            } else {
              this.dialog_scelta_ragione_sociale = true;
              this.filtro_ragione_sociale = null;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento = false;
          this.$refs.SnackbarQV.print("error", "Errore: " + err.toString());
        });
    },
    scegliNuovoInserimento() {
      this.dialog_scelta_inserimento = true;
    },
    unblock(item) {
      item.accesso_web = 0;
    },
    async confirmGenerateKey() {
      this.caricamento = true;
      const request = {
        controller: "secure",
        method: "PUT",
        richiesta: {
          action: "generatekey",
          id_utente: this.printItem.id_utente,
          password: this.enteredPassword,
          token: localStorage.user_token,
        },
      };

      await this.$store
        .dispatch("api6", request)
        .then(() => {
          this.caricamento = false;
          this.$refs.SnackbarQV.print("success", "Chiave Generata");
        })
        .catch((err) => {
          this.caricamento = false;
          this.$refs.SnackbarQV.print("error", "Errore: " + err.toString());
        });
      this.passwordDialog = false;
      this.aggiorna();
    },
    filterActivePerson() {
      this.filtro_attivo = !this.filtro_attivo;
    },
    printLoginQr(item) {
      this.enteredPassword = "";
      this.passwordDialogMode = 0;
      this.printItem = JSON.parse(JSON.stringify(item));
      this.passwordDialog = true;
    },
    generateKey(item) {
      this.show_pwd_dbs = false;
      this.enteredPassword = "";
      this.passwordDialogMode = 1;
      this.printItem = JSON.parse(JSON.stringify(item));
      this.passwordDialog = true;
    },
    confirmPasswordDialog() {
      if (this.passwordDialogMode == 0) {
        this.confirmPrint();
      } else if (this.passwordDialogMode == 1) {
        this.confirmGenerateKey();
      }
    },
    confirmPrint() {
      this.passwordDialog = false;
      this.printItem.password = this.enteredPassword;
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "printloginqr",
          utente: this.printItem,
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.enteredPassword = "";
            const contentType = "application/pdf";
            const b64Data = res.data.result;
            const blob = this.b64toBlob(b64Data, contentType);
            const blobUrl = URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = blobUrl;
            a.download = "login.pdf";
            document.body.appendChild(a);
            a.click();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    async salvaDialogSendEmail(arg) {
      await this.sendEmailCredenzialil(arg.buffer);
      this.salvaDialog();
    },
    async sendEmail(item) {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "sendcredentialemail",
          email: item.email,
          username: localStorage.prefisso_utente + "/" + item.username,
          password: item.password,
          nome: item.nome,
          cognome: item.cognome,
          token: localStorage.user_token,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return true;
          } else {
            this.$refs.SnackbarQV.print("error", "Errore nell'invio email.");
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print("error", "Errore nell'invio email.");
          return false;
        });
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    filtraUtente(filter) {
      if ((filter || "").trim() == "") {
        return this.filtro_attivo
          ? this.tabella.dati.filter((e) => e.attivo == 0)
          : this.tabella.dati.filter((e) => e.attivo == 1);
      }

      const result = new Array();
      this.tabella.dati.forEach((user) => {
        if (
          (user.nome || "")
            .toLowerCase()
            .indexOf(filter.toLowerCase().trim()) >= 0 ||
          (user.cognome || "")
            .toLowerCase()
            .indexOf(filter.toLowerCase().trim()) >= 0
        ) {
          result.push(user);
        }
      });
      return this.filtro_attivo
        ? result.filter((e) => e.attivo == 0)
        : result.filter((e) => e.attivo == 1);
    },
    aggiorna() {
      this.getUtenti();
      this.getProfili();
      this.getAzienda();
    },
    cambiaPassword() {
      this.dialog.buffer.new_pass = true;
      this.dialog.buffer.password = null;
    },
    getCodiceProfilo(id_profilo) {
      for (let i = 0; i < this.profili.length; i++) {
        if (this.profili[i].id_profilo_utente == id_profilo) {
          return this.profili[i].cod_profilo_utente;
        }
      }
      return null;
    },
    getProfili() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getProfili",
          token: localStorage.user_token,
        },
      };

      this.caricamento = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento = false;
          if (res.status === 200) {
            this.profili = [];
            this.profili = res.data.result.profili;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getUtenti() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getUtenti",
          token: localStorage.user_token,
        },
      };

      this.caricamento = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento = false;
          if (res.status === 200) {
            this.tabella.dati = [];
            this.tabella.dati = res.data.result.utenti;
            this.utenti_ori = res.data.result.utenti;
            for (let i = 0; i < this.tabella.dati.length; i++) {
              this.tabella.dati[i].new_pass = false;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile caricare i dati."
          );
        });
    },
    getAzienda() {
      let request = {
        controller: "global",
        method: "POST",
        richiesta: {
          action: "getazienda",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api6", request)
        .then((res) => {
          if (res.data.statusCode === 200) {
            this.azienda = res.data.result;
          } else {
            console.log("error: " + res.data.statusCode);
          }
        })
        .catch((err) => {
          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          console.error(err);
        });
    },
    mostraDialog(riga, tabella) {
      if (riga == null) {
        this.newUser = true;
      } else {
        this.newUser = false;
      }
      this.boolSendEmail = false;
      this.boolResetKey = false;
      this.pwd_utente_amm_db = 0;
      this.dialog.mostra = true;
      let indice = tabella.indexOf(riga);
      this.dialog.indice = indice;
      let campi = Object.keys(this.dialog.buffer);
      for (let i = 0; i < campi.length; i++) {
        this.dialog.buffer[campi[i]] = indice < 0 ? null : riga[campi[i]];
        if (
          (campi[i] == "attivo" || campi[i] == "attivo_quickhr") &&
          indice < 0
        ) {
          this.dialog.buffer[campi[i]] = 1;
        } else if (campi[i] == "new_pass" && indice < 0) {
          this.dialog.buffer[campi[i]] = true;
        }
      }
      let that = this;
      this.$nextTick(function () {
        that.$refs.form.resetValidation();
      });
    },
    async salvaDialog() {
      if (!this.$refs.form.validate()) {
        return;
      }

      for (const user of this.tabella.dati) {
        if (
          user.username == this.dialog.buffer.username &&
          user.id_utente != this.dialog.buffer.id_utente
        ) {
          this.$refs.SnackbarQV.print(
            "error",
            "Esiste già un'utente con lo stesso username."
          );
          return;
        }

        // Controllo  che il codice fiscale non sia nullo se sto salvando attivo_quickhr
        if (
          this.dialog.buffer.attivo_quickhr == 1 &&
          (this.dialog.buffer.cod_fiscale == null ||
            this.dialog.buffer.cod_fiscale === "")
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Compilare il codice fiscale per usare QuickTeam."
          );
          return;
        }
      }

      if (this.dialog.buffer.mittente_email == "persona") {
        let mail_persona = this.dialog.buffer.email
          ? this.dialog.buffer.email
          : "";
        let mail_azienda = this.azienda[0].email ? this.azienda[0].email : "";
        let mail_persona_split = mail_persona.toString().split("@");
        let mail_azienda_split = mail_azienda.toString().split("@");
        if (mail_persona_split.length < 2) {
          this.$refs.SnackbarQV.print(
            "error",
            "Email della persona non valida."
          );
          return;
        }
        if (mail_azienda_split.length < 2) {
          this.$refs.SnackbarQV.print(
            "error",
            "Email della azienda non valida."
          );
          return;
        }
        mail_persona_split = mail_persona_split[1].split(".");
        mail_azienda_split = mail_azienda_split[1].split(".");
        if (mail_persona_split[0] != mail_azienda_split[0]) {
          this.$refs.SnackbarQV.print("error", "Dominio mail non valido.");
          return;
        }
      }

      // Logica vecchia: aggiorna la tabella intera.
      /*if (this.dialog.indice < 0) {
        let clone = Object.assign({}, this.dialog.buffer);
        clone.validita = 1;
        clone.attivo = clone.attivo == 1 ? 1 : 0;
        clone.attivo_quickhr = clone.attivo_quickhr == 1 ? 1 : 0;
        clone.id_personale = -1;
        clone.new_pass = true;
        this.tabella.dati.push(clone);
      } else {
        let campi = Object.keys(this.dialog.buffer);
        for (let i = 0; i < campi.length; i++) {
          this.tabella.dati[this.dialog.indice][campi[i]] =
            this.dialog.buffer[campi[i]];
        }
      }*/

      // Aggiorno i dati dell'utente alla chiusura della finestra di dialogo.

      let set = await this.setUtenti("dialog");
      if (set) this.dialog.mostra = false;

      if (this.boolSendEmail == true) {
        // Se serve, mando un'email.
        this.caricamento = true;
        await this.sendEmail(this.dialog.buffer);
        this.caricamento = false;
      } else if (this.boolResetKey == true || this.pwd_utente_amm_db == 1) {
        // Se serve, faccio il restore della chiave utente per i DBS.
        this.restoreUserKey();
      }
    },
    restoreUserKey() {
      let request = {
        controller: "secure",
        method: "PUT",
        richiesta: {
          action: "restoreuserkey",
          token: localStorage.getItem("user_token"),
          id_utente: this.dialog.buffer.id_utente,
          password: this.dialog.buffer.password,
          pwd_utente_amm_db: this.pwd_utente_amm_db,
        },
      };

      this.$store
        .dispatch("api6", request)
        .then((res) => {
          if (res.status === 200) {
            return;
          } else {
            this.alert = {
              message: "Errore nella rigenerazione della chiave crittografica.",
              show: true,
              error: true,
            };
          }
        })
        .catch((err) => {
          console.error(err);
          this.alert = {
            message: "Errore nella rigenerazione della chiave crittografica.",
            show: true,
            error: true,
          };
        });
    },
    async setUtenti(arg) {
      let request = {
        controller: "Modulo",
        method: "PUT",
        richiesta: {
          action: "setutenti",
          token: localStorage.user_token,
          utenti: arg == "tabella" ? this.tabella.dati : [this.dialog.buffer],
        },
      };

      this.caricamento = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento = false;
          if (res.status === 200) {
            this.aggiorna();
            this.$refs.SnackbarQV.print(
              "success",
              "Dati salvati con successo."
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore durante il salvataggio."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.caricamento = false;
          if (
            JSON.parse(err?.response?.data?.message)?.result.includes(
              "Codice fiscale"
            )
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              JSON.parse(err?.response?.data?.message)?.result
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore durante il salvataggio."
            );
          }
          return false;
        });
    },
    toggleValidita(riga) {
      riga.validita = riga.validita == 0 ? 1 : 0;
      this.setUtenti("tabella");
    },
  },
};
</script>